var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPosTerminal = function SvgPosTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H9v3h6V1ZM7.5 2.5H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1.25v3a.75.75 0 0 0 .75.75h8a.75.75 0 0 0 .75-.75v-3H18a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1h-1.5V4h1v13h-11V4h1V2.5Zm1.25 18.25V18.5h6.5v2.25h-6.5ZM8.262 14h7.482v1.5H8.262V14Zm-.012-4V6h7.5v4h-7.5Zm1.5-1.5h4.5v-1h-4.5v1Z",
    fill: "#1D1737"
  })));
};
export default SvgPosTerminal;